import Vue from 'vue'
import Component from 'vue-class-component'
import { ProductApiModel } from '@/interfaces/ProductApiModel'
import { OptionApiModel } from '@/interfaces/OptionApiModel'
import { namespace } from 'vuex-class'
import { OptionCategoryApiModel } from '@/interfaces/OptionCategoryApiModel'
import { useOptionStore } from '@/store/modules/options'
import { OptionValidatorHelper } from '@/helpers/OptionValidatorHelper'

const currentModel = namespace('currentModel')

@Component
export class OptionValidator extends Vue {
  @currentModel.State
  public model!: ProductApiModel

  public optionStore = useOptionStore();

  public disableOption(optionItem: OptionApiModel): boolean {
    return new OptionValidatorHelper().disableOptionWithModel(optionItem, this.model)
  }

  public hideOption(optionItem: OptionApiModel): boolean {
    return optionItem.isHidden || new OptionValidatorHelper().hideOptionWithModel(optionItem, this.model)
  }

  public optionTooltipDescription(optionItem: OptionApiModel): string | undefined {
    return new OptionValidatorHelper().optionTooltipDescriptionWithModel(optionItem, this.model)
  }

  public hideCategory(category: OptionCategoryApiModel): boolean {
    return new OptionValidatorHelper().hideCategoryWithModel(category, this.model)
  }
}
